import React, { ReactNode } from 'react';
import { UniqMotorcycle } from '../api/dmdcuData';
import { DmdcuDataContext } from '../api/dmdcuDataContext';

export interface IAssetThumbnailUIProps {
  motorcycle: UniqMotorcycle;
  dataContext: DmdcuDataContext;
}

export class AssetThumbnailUI extends React.Component<IAssetThumbnailUIProps> {

  render() : ReactNode {

    const moto = this.props.motorcycle;

    const name1 = moto.name;
    const name2 = moto.name2;

    const assetType = 'motorcycle';
    const assetTypeGUIName = 'Motorcycle';
    const formattedID = moto.id;
    const isOwner =  moto.id !== 1;
    const isForSale = moto.isForSale();

    const assetDetailLink = `#${moto.getIDasHexValue()}`;

    return <div id={`item-nr-${formattedID}`} className={`certifiedItem ${assetType} ${isOwner ? 'owner' : ''} ${isForSale ? 'forSale' : ''}`} >
    <h2><a href={assetDetailLink} title={`Show details of ${name1}`}>{name1}</a></h2>
    <p className="type">{assetTypeGUIName}</p>
    <figure>
      <a href={assetDetailLink} title={`Show details to ${name1}`}>
        <img src={`assets/${this.props.dataContext.api.web3.utils.toUtf8(moto.imageRessourcesIPFSAddress)}.jpg`} alt={name1} />
      </a>
    </figure>
    <div className="infos">
      <div className="compareable-data">
        <div className="field field-1" id="field-modelbasename">
          <span className="label">Model Base Name</span>
          <span className="value">{name2}</span>
        </div>
        <div className="field field-6" id="field-customization-grade">
          <span className="label">Custom. grade</span>
          <span className="value">{moto.customizationGradeAsText()}</span>
        </div>
        <div className="field field-2" id="field-ps-kw-nm">
          <span className="label">PS/KW:</span>
          <span className="value">{`${moto.horsepower}/${moto.horsePowerAsKw()}`}</span>
        </div>
        <div className="field field-3" id="field-topspeed">
          <span className="label">Top speed:</span>
          <span className="value">{`${moto.topSpeed} km/h`}</span>
        </div>
        <div className="field field-4" id="field-originalbuilddate">
          <span className="label">Build date</span>
          <span className="value">{moto.buildDateFormatted()}</span>
        </div>
        <div className="field field-5" id="field-last-customization">
          <span className="label">Last custom.</span>
          <span className="value">{moto.changeDateFormatted()}</span>
        </div>

        <div className="field field-7" id="field-vintage-rating">
          <span className="label">Vintage rating</span>
          <span className="value">{moto.vintageGrade}</span>
        </div>
        <div className="field field-8" id="field-high-tech-rating">
          <span className="label">High-Tech rating</span>
          <span className="value">{moto.techGrade}</span>
        </div>
        <div className="clear"></div>
      </div>
      <p className="shortdesc">{moto.assetPlainText}</p>
    </div>

  </div>;
  }
}

export default AssetThumbnailUI;
